module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "chapnum"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("III")])]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Space had a floor. It stretched below the hurtling sunship as the ship’s transverters dragged the vessel from cupro-space to the ordinary dimensions of the X-World.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The floor looked like nothing more than a sheet of typing paper floating down towards the bottom of some translucent and undisturbed pool. But it grew. It grew as the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Micromegas")]), _vm._v(" burst towards it; it came upwards, upwards from its translucent and ripple-innocent pool, upwards, spread far beyond the confines of any pool, until it threatened to dwarf the limitless spread of starlight above and round it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The sunship was decelerating, tearing down through the resonating G’s in one grand orchestral crash as if ripping the rivets out of nature itself.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Unstirring and unstirred, Attica Saigon Smix sat with his wife Loomis watching the mighty floor of space rise to meet them. They were comfortable in their embracing chairs before the visiscreen, with Captain Ladore standing immaculate behind them.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("Loomis’s unchanging beauty was of a Persian kind, her face as smooth and beautiful as an Isfahan dome of cerulean china, her ")]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("hair sable and coiling, uncurled, about her neck with an intent of its own. She had rested one hand on the wrist of her husband.")])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("He—he whose least word to the computer pentagons of earth was unrecognised in every last household of its numberless warrens—he—boss of all bosses, last overlord of all commercial overlords—he—great communist-capitalist of the united capitalist-communist empire—he—Attica Saigon Smix of Smix-Smith Inc—was a pale shadow of a man. The slight pulsations of his ivory skin revealed, not the normal circulations of a normal blood-stream, but the unfaltering beat of internal servo-mechanisms.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He turned his head and smiled at her, at her who was more precious to him than the unendingly complex financial parasystems over which he held sway. Ghastly though his smile might have seemed to others, it woke an answering smile of love from her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Nearly there, my love.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Nearly there!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You weren’t bored by micro-space?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Not at all, Attica!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Nor I, with you beside me.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He turned his thin skull half-way towards Captain Ladore. ‘See to it that we disembark immediately we land. I have no desire that we be kept waiting.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Sir.’ The captain turned, barked briefly into the intercom by his side.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The orchestration had faded now into a depth beyond music or sound.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The great white floor, unshadowed by starlight, now stretched before them, magnificent, bleak, unbelievable, the logical extension of a zero-infinity nightmare topology, undiminished by distance, unfamiliarised by any proximity.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In a brief while, they touched down upon it, light as daylight on a snow-crowned peak. From the porcine bulk of the ship, gangways rolled out on all sides, gangways and the snouts of immense weapons, tender as the noses of blind moles.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("Attica Saigon Smix’s chair animated itself, curling about its master. It brought him to the vertical. He was on his feet. He proceeded forward, his wife by his side, ever watchful with her eyes of lapis lazuli. They moved to the nearest porter-shaft, sank languidly down it, emerged at a gangway, and were carried, whirringly, gently, speedily, down on to the surface of the immense floor of space.")])]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("She flinched and held more tightly to his arm. The all-recording cameras, perpetuating every moment of Attica Saigon Smix’s life-event-continuum, caught her gesture, and the Smix Carollers added a lyric for the re-showing.")]), _vm._v(" "), _c('div', {
    staticClass: "quote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("‘She flinched and held more tightly to his arm")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Magnificent in fright, brave in alarm ….’")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("From other gangways, minions were hastening down, their subordinate positions rendering them impervious to the impossibly grandiose exposure of their situation. By reason of their power, naked to the majesty of it, Attica Saigon Smix and his wife stood on infinity, stood on the immovable object, while the infinitely irresistible force of space flew over them. The floor felt warm, worn, hydroptic, apical, pinnate, like the flesh of a vulpine and voluptuous courtesan erotogenically dying.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Alone at last, my love.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Alone with you, dear Attica!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You like it here?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Well, it is kind of novel … Is it—you know—science or art?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Both, my love. Science and art. The two disciplines, once parallel, here unite. There’s been nothing like it before.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She gave a small laugh. ‘I’d think not! Does it need much—well, power?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("His chair trembled slightly about him. ‘Power? Until the War, there wasn’t this much power available. Only the prolapse of other dimensions, other universes, into ours allowed us to broach entire new energy-systems. You explain to her, Benchiffer …’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("His voice was trailing away, amplification fading. But the faithful Benchiffer, perspex-encased, was already at hand, scooping up his master’s wilting sentence like some sensitive plant, applying to it the unction of his own calcareous personality. ‘Yes, madam, this aponeurotic floor is maintained in stasis by a power-drain from some of the newly opened-up universes. The energy quotients appear to be roughly in equipoise, so that one year of the floor’s existence probably drains one year from the entropaic-output store of an entire universe.’")])]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I see … You mean we actually shorten people’s lives by us being here?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Well, lives do tend to shorten anyway, ma’am, even with no one there meddling.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Benchiffer fell back, more pallid than ever, aware he had transgressed beyond his brief—to expound science—into dealing with matters coming within the domain of ontology and philosophy. Not that there was much to choose between any of them nowadays …")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But Attica Saigon Smix seemed unaware of the transgression. His eye-like lenses took in the synclastic horizons all about him, and were refreshed by them. Here was peace from the rabid systems he nominally controlled, peace and a hideout the like of which had never before been devised.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He watched, chair-supported, as henchmen brought out holoscillators. In as much as he was capable of deriving pleasure through the intricate man-mechanism interfaces of his receptors, he derived pleasure from seeing the holoscillators come on.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They came on now, warmed, as the henchmen hurried out of the way. A lithoponic mist formed, bodied forth, boiled as if cupellation were in process, and objects took shape within the uneasy cloak of it—trees, flowers, benches, marrow plants male and female, forts and little fortresses, music boxes and barrel-organs, roundabouts, homes for cows and doggies.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Benchiffer!’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("‘Sir!’ Benchiffer twinkled as he moved, toes rotating like casters in the perspex.")])]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘That passage from that poet …’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Benchiffer remembered. A constant threat of instant demolition proved an ideal mnemonic in all situations.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Shakespeare, sir … “The great globe itself, Yea, all which it inherit, shall dissolve, And, like this insubstantial pageant faded, Leave not a rack behind …”’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘As this lot appears, I guess their equivalent is sort of disappearing in some other universe,’ said Loomis. Her husband patted her for her cleverness. Also, he liked the poem, even if it didn’t rhyme.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The pageant was growing rapidly substantial. Suddenly, it was "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("there.")]), _vm._v(" The cow homes and the cows, the trees, the little gay buildings, the huge butterflies, all in motion, bright as a lip in a dream, covering—yeah, covering the whole scab-devouring floor of space.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Want to walk, my love?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Yeah, sure.’ She wanted to walk when he did. Always. She was nice. So this was the paradise he had invented for her. Loomis. Love.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The cameras followed them, silent as hepatitis, drinking it all in, recording for posterity and their own delectation the slow stroll among these objects of Attica Saigon Smix’s invention. The trees were not trees, the butterflies not butterflies, the cows not cows, the buildings not buildings. They were delicate simplifications, pastiches of trees, butterflies, cows, and buildings, done in simplified shapes, executed in primary colours. The melons and flowers lying at their careless feet were detachable, embodied extracts of abstracts based on elementary pictures in nursery frescoes. Peace and infantilism met, with a smacking but pure kiss.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘It’s nice here …’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Good for you to get away from business.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Aren’t the cows cute?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I just love their pretty little dangling bells and—uh, udders. You’re a clever old thing, Attica, did I ever tell you that?’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("Every day she told him that. It was the secret of both their successes.")])]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("A cow was waddling by them, hat on head, gaudy melon-flower in chops, rocking quaintly from side to side. Three-dimensional and entirely touchable—rideable, even. Hygienic, too, of course. No defecations, no monstrous eructations of vile wind. Just a holobject, conjured by machines invented in the technological computer-laboratories of one of Smix-Smith’s subsidiaries.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And the yokel figure also waddling towards them was no more than a holman, also three-dimensional, entirely touchable, hygienic. Man, hat, comic smock, pipe, clogs, all of one inorganic substance, a projection as tangible, as much of the physical world as oak, and far less unmanoeuverable. It touched its comic floppy hat, blew a little chugging pasteboard smoke-ring from its corncob, and produced a message from its daisy-embroidered smock.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Benchiffer, read it.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Benchiffer took the wafer, held it in photoelectric hand, and intoned: ‘Gall-bladder to Rupture Six. Regret Spy-Bell Zero Zero Zero became nondetectable time-refererents 03071255T. Jupiter Police Five-Star Alert and Exo-Systems Search in Code Areas Burgess, Knight, Adlard, Cotton, and Conquest. Full Emergency. Possible coordinates follow message. Suggest Red Rupture despatch dopple repeat dopple subiter Gall-Bladder Suite Beta. All parameters Bilious repeat Bilious advised. War footing. Transcendent. Jupiter Five-Star Alert. Burgess, Knight, Adlard, Cotton, Conquest. Red Rupture. Reddleman. QLLTX5973328764983AA448. Four-second destruct. Reddleman. Gabbice. Gall-Bladder Rupture Six.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Is it important, darling?’ Loomis asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The four seconds was up. The holman was blanked for a moment as the wafer destructed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I’m Red Rupture,’ Attica Saigon Smix said, fingering certain keys on his chair. He turned slowly round, beginning to perambulate back through the tent-shaped trees towards "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Micromegas.")]), _vm._v(" He signalled to Captain Ladore, watchful at the gangway.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("‘What’s it mean, darling?’ asked Loomis. She was all female; in her adolescence, she had liked to shower in company with her male cousins, and with her sister, Glamis. It had proved the beginning of a very cleanly way of life.")])]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘It’s that scab-devouring spy-bell near Jupiter that we’ve been keeping tabs on. It could do us no harm—we just didn’t know who owned it. How does it "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("vanish")]), _vm._v(" just like that? When I get to Gall-Bladder—Oh, Ladore! Is it possible to project a dopple of me to Gall-Bladder from this location?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Immaculate Ladore was a projection himself, one of the multiple embodiments of Computer Complex detached to serve—and survey—the master of the Smix-Smith universe.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘It means double transcendence,’ Ladore replied. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("‘Micromegas")]), _vm._v(" carries the necessary equipment. We could perform the operation in ordinary space. Here, in this continuum, we lack energy. We shall have to tap the floor—it’s pure energy ready to hand.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Get with it.’ But the companalog had anticipated the order; as the boss rolled up the gangway, syphon cables were snaking down, taking a bite into the space-floor.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He looked back. She fluttered a hand. Ever the loving wife.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Another companalog was waiting inside, guiding him down to Trexmissions Bay. Orderly movement, high-level activity, low-order sounds, non-smells—the entire synthetic, synapse-speeding gestalt of a multi-space sunship. Pent with emotion, null-emotion, and the fastest static known to man. Hyperthyroid, hythritic, the perfect kinematics of non-perceivable mobility in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("n")]), _vm._v(" dimensions. Real men, fake men—holmans, companalogs, cyborgs, androids, robots, down to espergdummies—all with a purpose not entirely or entirely not their own—even the real men, so far as ‘real’ was a term any more with coordinates in any actual world, drugged or gutted in some way or hooked to electroidal reflex. Eyes everywhere, and some anxious eye-movement. But never gaze meeting gaze. Never eye-contact. Deflection saved reflection.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("They brought him reverently to an intolerable prone position and swung the massive dopplegangster ovens round about his frame.")])]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("A technician said, and a slight tendency to hairiness along the side of the neck suggested he was a real man, however controlled, ‘You know, sir, that you will have to rest here in lightly comative condition while your dopple is away? The life-death interface could be somewhat critical over the proposed distance.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Understood.’ No baby-talk for these men. ‘Can you peel off an extra dopple to keep my wife happy, keep her company?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘We could peel off a half-dozen under normal circumstances.’ Dangerous talk to Smix of Smix-Smith, the normal circumstances being understood to refer to people in sound health, making their way along the mulcting trajectories of life unaided by excessive servos. ‘But we might find in the present case that doubling dopplers could lead to hyperemesis and actuality-decay. What we can do is take a soul-sliver and duplicate on the holoscope, to form a semi-project. Then we’d use companalog transjects to project speech transferences based on your recorded impulse-patterns.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Faithful, detesticled Benchiffer was at the wizened elbow to render the technical jargon down into boss jargon.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You might find yourself in excess of critical, psyche-wise, if you projected more than one dopple. But they can take a stillmoment-transfix and give it pseudo-life and speech by souping it up through computer-project channels, using your life-channels from the banks.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Will that "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("thing")]), _vm._v(" be any good for Loomis?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘It could repeat yourself—itself—a bit.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘It might keep her happy. Let’s go. Gall-Bladder.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The ovens began to radiate. The old body they contained, yeah, and all which it inherited, began to dissolve and fade …")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("… Leaving behind on the floor-world a double which moved slowly out in the fake sunlight among the nursery properties to greet Loomis, tasty of hand and lip and gesture …")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("… And projecting through the incomprehensible mathematical intricacies (so complex that they were only marshalled in orderly impulses in one special maroon-red-coded section of computer-complex’s primal think-bank and in no human think-tank) separating a rather problematical "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("here")]), _vm._v(" from a rather problematical "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("there")]), _vm._v(" a capable and angry-alert dopple Attica Saigon Smix into the high (and highly fortified) chambers of a subterranean building in Easeaboard, N.A., otherwise known in the day’s code (leaving this special definition of ‘day’ to be unravelled by others) as Gall-Bladder.")])]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The guys in Gall-Bladder were still sweating blood about the whereabouts of the mystery spy-bell.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That spy-bell—known to its occupants, with whom we have shortly to deal, as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Doomwitch")]), _vm._v("—marks with its disappearance the appearance of catastrophe in my narrative.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My job, as I see it, is to relate the events in some sort of order, to produce a linear continuance which I believe can be perceived in the haphazard-seeming flow of chance, motive, and encounter. The next generation, less wedded to ideas of causality and effect (‘liberated by the neuro-sciences’, as they would claim!) will have to reinterpret the whole damned tangled business for themselves.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At about this time, I was wheeling across the courtyard at Slavonski Brod Grad with old George Hornbeck, when he said something interesting on the subject.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was mid-morning, everywhere was quiet. Most of the distinguished guests we met at the party were still recovering from the evening before. Becky was up and about, radiant as ever—but meditating at this hour, as was her habit. Only Dinah Sorbutt, comfortably and almost completely pregnant, sat on a teak bench with her feet up in the sun and had nothing to do.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("‘Durrant, I was talking to Becky last night,’ George told me. ‘Profound girl, my daughter. We were talking about whether there was a pattern to life, and it was a fairly sober discussion. Becky said she could always console herself by seeing a pattern—wallpaper, ")]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("she called it—so that, even when things were bad, she knew something better was coming.’")])]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘It’s a young girl’s view,’ I said. ‘But Becky has real sensibility—in that respect she takes after you.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I don’t know about that. I’m old and I miss England. I can’t believe Britain’s gone. I’m more conscious of the awful rifts of life than of its pattern. England is one of the rifts. And, you, Durrant—do you mind my saying it?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘That I lost both legs in the war? How can I "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("mind")]), _vm._v("?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You face up to it well, my boy. And you use your prosthetic wheels well. Becky and I were wondering … how far it indisposed you mentally for action …’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I manage better than Mike’s younger brother, give me that. You know, I suppose, that "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("he")]), _vm._v(" stays alone in their place in California, on some drug or other? He’s about my age, he got both his legs shot off, too—part of a pattern, Becky might say. But I’m not like him, George—in circumstances, maybe, but not in reaction to them—I’m more like Mike, I’m going to do something with "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("my")]), _vm._v(" life.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("George smiled and nodded, looking down at the path, glancing at his watch. Soon it would be time for us to work.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Slavonski Brod Grad was not always a place of merriment. The parties were growing fewer as the economic situation deteriorated.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("George Hornbeck and I fought our own little battle against the monolithic state threatening to engulf the world once the Cap-Comm Treaty was really a going concern.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We published creative pornography. Much of the material, mainly in the form of comic strips, was supplied by our Brazilian ally, da Perquista Mangista. We were backed by Brazilian money as well.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Our one-room offices were in the castle. We called ourselves P.P.P., which stood for Pornography Permissive and Progressive. Strangely enough, the idea had come from Russia, where their "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("samizdat,")]), _vm._v(" or do-it-yourself publishing, led the world.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("Our puny blow against machine-culture was done by machines which mainly ran themselves. We could afford a few minutes more in the fresh air.")])]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Let’s sit on a bench and sun ourselves,’ George said. ‘It’s a traditional old man’s occupation. We don’t have to talk to Dinah. She’s a foolish woman. I wonder why she will tell nobody who the father of her infant is?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We sat down together, and he started to discuss paternity. He did ramble sometimes. Then he said, ‘Your other burden is the loss of your parents. I know your mother is doing good work on Mars, but she should be here with you and Choggles. Choggles is getting too precocious for her own boots … No, that wasn’t what I meant to ask you. Durrant, what "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("are")]), _vm._v(" you intending to do with your life?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Well, why not tell him?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I’m intending to write a novel. I’m not interested in holoplays, and pornography has its limitations. I want to write a good old-fashioned novel, with no more ambition in it than to reflect pleasure and disgust in what I see round me.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At that time, I was not entirely serious. I did not entirely intend to write a novel, merely to keep old George, whom I regarded highly, content. Certainly, I did not intend to write "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("this")]), _vm._v(" novel. But, the neuro-scientists declare, every human act can be analysed in chemical terms; so perhaps that conversation predetermined this book.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("I hereby determine not to intervene in the narrative again—or not overtly. But, bereft of my own legs, I intend to play a longlegged God—the new kind of god, god of creation, slave of the creation it has created, as man has now become slave of the systems he created, according to the new neuro-philosophy. For—why not admit it—I’m vexed already with my task: by what scale of values is it more worthwhile to create or read a novel, even one with real people in it, than to opt for hallucinations provoked by "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("root,")]), _vm._v(" as does my dark obverse, my brother, over in California?—Except ")]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("in this: that drug-dreams cover old ground, and look back; I try to look forward, to encompass new thought.")])]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Accordingly, I will travel with my characters all round space and time. If I do that, I will also travel into their thoughts. Why not? Mind is now proven an epiphenomenon of space and time! You see I write a story on deterministic principles.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The first flutter of this came to me as I sat in the sun with George Hornbeck, for I said, ‘I’d like to try and invent what others think. Thought has always seemed to me easier to understand than action.’ (And there I finish telling what I said.)")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He gave his dry laugh. ‘Understanding is a relative expression. But we can all of us always do with a little more of it. Go ahead, Durrant, see what you can do for us—and yourself!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He left me, walking quite strongly across the wide courtyard, an old man missing England.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d62fef8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_Chapter03.vue
// module id = 78
// module chunks = 0